import { createSelector } from 'reselect';

import { DEFAULT_FILTER } from '../../constants';

const userStore = (store) => store.user;
const routerLocation = (store) => store.router.location;

export const initialFilterSelector = createSelector([
  routerLocation,
  userStore,
  (store, options = {}) => options,
], (location, user, options) => [
  user,
  location,
  options.filter || DEFAULT_FILTER,
]);
